import React from 'react';
import './styles.css';
import Header from './Header'; // Укажите правильный путь к вашему компоненту
import Headerlow from './HeaderLow';
import CategoriesSection from './CategoriesSection';
import Develop from './Develop';
import Gisprocessing from './Gisprocessing';
import About from './Aboutus';
import Footer from './Footer';


const App = () => {
  return (
    <div>
    <Header />
    <Headerlow />
    <CategoriesSection />
    <Develop />
    <Gisprocessing />
    <About />
    <Footer/>
    </div>
  );
};

export default App;